import { showModal, hideModal } from '../twd/twd'

const modals = []


// {view:...}
export const setModals = (m) => {
    if (!m) return
    let n = -1
    do {
        n = modals.find(({view}) => view===m.view)
        modals.splice(n, 1)
    } while(n >= 0)

    modals.push(m)
}

export const showModals = () => {
    const a = modals.shift()
    if (!a || !('view' in a)) return

    showModal(a)
}

export const hideModals = () => {
    hideModal()
    setTimeout(() => {
        showModals()
    })
}

export const resetModals = () => {
    hideModals()
    modals.length = 0
}

export default () => {
    return {
        setModals,
        reset: resetModals,
        resetModals,
        showModals,
        hideModals,        
    }
}